import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import Form from "./Form";
import {UsePost, UsePut} from "../../hooks/http";
import {UseMessage} from "../../hooks/UseMessage";

const Edit = ({id}) => {
    const [sms, setSms] = useState()
    const [errors, setErrors] = useState()
    const [enterprises, setEnterprises] = useState()
    const [content, setContent] = useState('')
    const [isLoading, setIsLoading] = useState(true)


    const GetSms = async () => {
        const requestSms = await UsePut(
            `/sms/get/${id}`,
            {data: {limit: 1, offset: 0, _id: id}}
        )

        const requestEnterprises = await UsePut(
            `/enterprises/get`,
            {data: {offset: 0}, toArray: true, propLabel: 'name'}
        )

        return {
            sms        : requestSms?.entities[0],
            enterprises: requestEnterprises
        }
    }


    useEffect(() => {
        GetSms().then((response) => {
            setSms(response.sms)

            if(content.length === 0){
                setContent(response.sms?.content)
            }

            setEnterprises(response.enterprises)
            setIsLoading(false)
        })
    }, [content])


    const handleUpdate = (PostData) => {
        setIsLoading(true)
        UsePost(
            `/sms/upsert/${id}`,
            {data: {info: PostData}}
        ).then((response) => {
            if (response.code >= 200 && response.code <= 299) {
                UseMessage('success', 'Sms has been successfully updated')
            } else {
                setErrors(response.errors)
            }
            setIsLoading(false)
        })
    }


    const changeContent = (ev) => {
        setContent(ev.target.value)
    }


    const insertVariable = (variable) => {
        if(!content.includes(` [${variable}]`)){
            const newContent = content + ` [${variable}]`
            setContent(newContent)
        }
    }


    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <Form
                                sms={sms}
                                errors={errors}
                                content={content}
                                isReady={!isLoading}
                                onSubmit={handleUpdate}
                                enterprises={enterprises}
                                onInsertVariable={insertVariable}
                            />
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Edit